import React, { useEffect, useCallback, useRef } from "react";
import PropTypes from 'prop-types';
import { Html5Qrcode } from "html5-qrcode";
import "./index.sass";

const QRCodeReaderCamera = ({ className, onResult }) => {
	const html5QrCodeRef = useRef(null);

	const handleResult = useCallback(
		async (decodedText) => {
			onResult(decodedText);
			await stopScanner();
		},
		[onResult]
	);

	const startScanner = async () => {
		await stopScanner();
		try {
			html5QrCodeRef.current = new Html5Qrcode("QRCodeReaderCameraContainer");
			await html5QrCodeRef.current.start(
				{ facingMode: "environment" },
				{
					fps: 30,
					// Scan most of the view: a fixed 150px box made credentials hard to read
					qrbox: (viewfinderWidth, viewfinderHeight) => {
						const size = Math.max(150, Math.floor(Math.min(viewfinderWidth, viewfinderHeight) * 0.8));
						return { width: size, height: size };
					},
					experimentalFeatures: { useBarCodeDetectorIfSupported: true },
					videoConstraints: {
						width: { ideal: 1920 },
						height: { ideal: 1080 },
						facingMode: "environment"
					}
				},
				handleResult,
				(error) => console.log("QR Code scan error:", error)
			);
		} catch (error) {
			console.error("QR Code start error:", error);
		}
	};

	const stopScanner = async () => {
		if (html5QrCodeRef.current) {
			try {
				await html5QrCodeRef.current.stop();
				html5QrCodeRef.current.clear();
				html5QrCodeRef.current = null;
			} catch (error) {
				console.warn("Error stopping the scanner:", error);
			}
		}
	};

	useEffect(() => {
		startScanner();

		return () => {
			stopScanner();
		};
	}, []);

	return (
		<div className={`QRCodeReaderCamera ${className}`}>
			<div className="QRCodeReaderCamera__Container">
				<div className="QRCodeReaderCamera__Container__Wrapper">
					<div id="QRCodeReaderCameraContainer" className="QRCodeReaderCamera__Container__Wrapper__Webcam"></div>
				</div>
			</div>
		</div>
	);
};

QRCodeReaderCamera.propTypes = {
	className: PropTypes.string,
	onResult: PropTypes.func.isRequired
};

QRCodeReaderCamera.defaultProps = {
	className: ''
};

export default QRCodeReaderCamera;
